import NameField from "./NameField";

class ActivityNameField extends NameField {
  get isMovableInLayout() {
    return true;
  }
}

export default ActivityNameField;
